module.exports = __webpack_public_path__ + "img/iconCC-Social2.68f2fb3d.png";